import { render, staticRenderFns } from "./SaveCompleted.vue?vue&type=template&id=daab3600"
import script from "./SaveCompleted.vue?vue&type=script&lang=js"
export * from "./SaveCompleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports